import * as CreateFilledTestTypes from 'src/actions/filled-test/create/Types';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import {
  CreateFilledAptitudeTestAction,
  CreateFilledAptitudeTestSuccess
} from 'src/actions/filled-test/create/CreateFilledAptitudeTest.actions';

export interface CreateFilledAptitudeTestState {
  filledAptitudeTest?: FilledAptitudeTest;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateFilledAptitudeTestState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateFilledAptitudeTestReducer(state: CreateFilledAptitudeTestState = initialState,
                                                action: CreateFilledAptitudeTestAction): CreateFilledAptitudeTestState {
  switch (action.type) {
    case CreateFilledTestTypes.CREATE_FILLED_APTITUDE_TEST_ATTEMPT:
      return {...state, filledAptitudeTest: undefined, loading: true, error: false};
    case CreateFilledTestTypes.CREATE_FILLED_APTITUDE_TEST_SUCCESS:
      const filledTest: FilledAptitudeTest = (action as CreateFilledAptitudeTestSuccess).payload.aptitudeTest;
      return {...state, filledAptitudeTest: filledTest, loading: false, error: false};
    case CreateFilledTestTypes.CREATE_FILLED_APTITUDE_TEST_FAILURE:
      return {
        ...state,
        filledAptitudeTest: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filled-test/CreateFilledAptitudeTestReducer.tsx